<template>
  <div
    :class="{'lamp-notif-sized-container-for-mobile': this.isMobile, 'lamp-notif-sized-container-for-desktop-with-notifs': !this.isMobile && notifications.length > 0}"
    :style="{'height': this.isMobile ? '100vh' : 'unset'}">
    <div :class="{'lamp-notif-container-mobile': this.isMobile}" class="d-flex flex-column lamp-notif-container">
      <template v-if="notifications.length > 0">
        <div
          v-for="(notification, index) in notifications"
          :key="index"
          v-intersect="() => markAsViewed(notification)"
          class="lamp-notif d-flex"
          @click="updateNotifAndRedirect(notification,$event)">
          <!-- icon -->
          <div class="lamp-notif-icon-part d-flex justify-content-center">
            <i :class="[getIconForNotificationType(notification)]"
               class="ph-custom align-self-center"/>
          </div>
          <!-- texts -->
          <div class="lamp-notif-texts-part">
            <div class="lamp-notif-timeText">{{ convertTimestampToRelativeDate(notification.date) }}</div>
            <p class="lamp-notif-content">
              <span class="lamp-notif-title">{{ notification.title }}</span>
              <span class="lamp-notif-description">{{ notification.body }}</span>
            </p>
          </div>
          <!-- new -->
          <div class="lamp-notif-new-part d-flex justify-content-end">
            <transition name="fade">
              <div v-if="!notification.updateViewed" class="lamp-notif-new">
                {{ $t('new.notif') }}
              </div>
            </transition>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="lamp-no-notif">
          {{ $t('Notifs.none') }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";
import {eventBus} from "../../main";

const onIntersect = {
  bind(el, binding) {
    const options = {
      root: null,
      threshold: 0.8
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          binding.value();
        }
      });
    }, options);
    el.__vueObserver__ = observer;
    observer.observe(el);
  },
  inserted(el, binding) {
    const options = {
      root: null,
      threshold: 0.8
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          binding.value();
        }
      });
    }, options);
    observer.observe(el);
    observer.takeRecords().forEach(entry => {
      if (entry.isIntersecting) {
        binding.value();
      }
    });
  },
  unbind(el) {
    el.__vueObserver__.disconnect();
  }
};

const NotificationTypeEnum = {
  ANNONCE_ACCEPTED: 'ANNONCE_ACCEPTED',
  ID_VALIDATED: 'ID_VALIDATED',
  WATCHER_MATCH_INVALID: 'WATCHER_MATCH_INVALID',
  WATCHER_MATCH_REFUSED: 'WATCHER_MATCH_REFUSED',
  ID_REFUSED: 'ID_REFUSED',
  ANNONCE_DELAY_PASSED: 'ANNONCE_DELAY_PASSED',
  ANNONCE_REFUSED: 'ANNONCE_REFUSED',
  PHOTOS_REFUSED: 'PHOTOS_REFUSED',
  WATCHER_VEHICLE_FOUND_IN_FUNCTION: 'WATCHER_VEHICLE_FOUND_IN_FUNCTION',
  VICTIM_VEHICLE_FOUND_IN_FUNCTION: 'VICTIM_VEHICLE_FOUND_IN_FUNCTION',
  WATCHER_VEHICLE_FOUND_DESTROYED: 'WATCHER_VEHICLE_FOUND_DESTROYED',
  VICTIM_VEHICLE_FOUND_DESTROYED: 'VICTIM_VEHICLE_FOUND_DESTROYED',
  LAMPIONS_GAINED: 'LAMPIONS_GAINED',
  LEVEL_GAINED: 'LEVEL_GAINED',
  NEW_NEAR_VEHICLES: 'NEW_NEAR_VEHICLES',
  NEW_ALERT_VEHICLES: 'NEW_ALERT_VEHICLES',
  ANNONCE_TO_COMPLETE: 'ANNONCE_TO_COMPLETE',
  LAMPIONS_LOST: 'LAMPIONS_LOST',
  LAMPIONS_ADDED: 'LAMPIONS_ADDED',
  LAMPIONS_REMOVED: 'LAMPIONS_REMOVED'
};

export default {
  name: 'NotifsMenu',
  directives: {
    intersect: onIntersect
  },
  props: {
    windowHeight: null,
    isMobile: false
  },
  data() {
    return {
      notifications: [],
      notifTypes: [],
      notifTypesToExclude: [],
      objectTypes: ["User", "Annonce", "Lampions"],
      objectTypesToExclude: []
    }
  },
  async mounted() {
    await this.fetchMyNotifications();
    this.markInitiallyVisibleNotifications();
  },
  computed: {
    getIconForNotificationType() {
      return (notification) => {
        let baseClass = "";
        let iconClass = "";

        switch (notification.type) {
          case NotificationTypeEnum.ANNONCE_ACCEPTED:
          case NotificationTypeEnum.ID_VALIDATED:
            iconClass = "ph-seal-check-notif";
            break;

          case NotificationTypeEnum.WATCHER_MATCH_INVALID:
          case NotificationTypeEnum.WATCHER_MATCH_REFUSED:
          case NotificationTypeEnum.ID_REFUSED:
          case NotificationTypeEnum.ANNONCE_DELAY_PASSED:
          case NotificationTypeEnum.ANNONCE_REFUSED:
          case NotificationTypeEnum.PHOTOS_REFUSED:
            iconClass = "ph-x-circle";
            break;

          case NotificationTypeEnum.WATCHER_VEHICLE_FOUND_IN_FUNCTION:
          case NotificationTypeEnum.VICTIM_VEHICLE_FOUND_IN_FUNCTION:
            iconClass = "ph-hands-clapping";
            break;

          case NotificationTypeEnum.WATCHER_VEHICLE_FOUND_DESTROYED:
          case NotificationTypeEnum.VICTIM_VEHICLE_FOUND_DESTROYED:
            iconClass = "ph-thumbs-up";
            break;

          case NotificationTypeEnum.LAMPIONS_GAINED:
          case NotificationTypeEnum.LAMPIONS_ADDED:
            iconClass = "ph-hand-coins-notif-yellow";
            break;

          case NotificationTypeEnum.LEVEL_GAINED:
          case NotificationTypeEnum.NEW_NEAR_VEHICLES:
          case NotificationTypeEnum.NEW_ALERT_VEHICLES:
            iconClass = "ph-megaphone";
            break;

          case NotificationTypeEnum.ANNONCE_TO_COMPLETE:
          case NotificationTypeEnum.LAMPIONS_LOST:
          case NotificationTypeEnum.LAMPIONS_REMOVED:
          default:
            iconClass = "ph-warning";
            break;
        }

        if (notification.type === NotificationTypeEnum.ANNONCE_ACCEPTED || notification.type === NotificationTypeEnum.ID_VALIDATED) {
          if (notification.clicked)
            iconClass = "ph-seal-check-notif-grey";
          else
            iconClass = "ph-seal-check-notif-yellow";
        } else if (notification.type === NotificationTypeEnum.ANNONCE_ACCEPTED || notification.type === NotificationTypeEnum.ID_VALIDATED) {
          if (notification.clicked)
            iconClass = "ph-hand-coins-notif-yellow";
          else
            iconClass = "ph-hand-coins-notif-grey";
        } else {
          if (notification.clicked)
            baseClass = "lamp-notif-icon-grey";
          else
            baseClass = "lamp-notif-icon-yellow ";
        }

        return `${baseClass} ${iconClass}`;
      };
    }

  },
  methods: {
    async fetchMyNotifications() {
      let data = new FormData();
      if (this.notifTypes) data.append('notifTypes', this.notifTypes);
      if (this.notifTypesToExclude) data.append('notifTypesToExclude', this.notifTypesToExclude);
      if (this.objectTypes) data.append('objectTypes', this.objectTypes);
      if (this.objectTypesToExclude) data.append('objectTypesToExclude', this.objectTypesToExclude);

      try {
        const response = await api.post("/lampNotification/getAllForUser", data);
        this.notifications = response.data.map(notification => ({
          ...notification,
          updateViewed: notification.viewed
        }));
        this.showAlert = true;
      } catch (error) {
        console.log("error", error);
      }
    },
    convertTimestampToRelativeDate(timestamp) {
      if (!timestamp || timestamp == -1) return '';
      const currentTimestamp = Date.now();
      const diffInMs = currentTimestamp - timestamp;

      const secondsInMs = 1000;
      const minutesInMs = secondsInMs * 60;
      const hoursInMs = minutesInMs * 60;
      const daysInMs = hoursInMs * 24;
      const monthsInMs = daysInMs * 30; // Environ 30 jours par mois
      const yearsInMs = daysInMs * 365; // Environ 365 jours par an

      if (diffInMs < secondsInMs) {
        return "à l'instant";
      } else if (diffInMs < minutesInMs) {
        const secondsAgo = Math.floor(diffInMs / secondsInMs);
        return `il y a ${secondsAgo} ${secondsAgo === 1 ? 'seconde' : 'secondes'}`;
      } else if (diffInMs < hoursInMs) {
        const minutesAgo = Math.floor(diffInMs / minutesInMs);
        return `il y a ${minutesAgo} ${minutesAgo === 1 ? 'minute' : 'minutes'}`;
      } else if (diffInMs < daysInMs) {
        const hoursAgo = Math.floor(diffInMs / hoursInMs);
        return `il y a ${hoursAgo} ${hoursAgo === 1 ? 'heure' : 'heures'}`;
      } else if (diffInMs < monthsInMs) {
        const daysAgo = Math.floor(diffInMs / daysInMs);
        return `il y a ${daysAgo} ${daysAgo === 1 ? 'jour' : 'jours'}`;
      } else if (diffInMs < yearsInMs) {
        const monthsAgo = Math.floor(diffInMs / monthsInMs);
        return `il y a ${monthsAgo} ${monthsAgo === 1 ? 'mois' : 'mois'}`;
      } else {
        const yearsAgo = Math.floor(diffInMs / yearsInMs);
        return `il y a ${yearsAgo} ${yearsAgo === 1 ? 'an' : 'ans'}`;
      }
    },
    markAsViewed(notification) {
      if (!notification.updateViewed) {
        notification.updateViewed = true;
      }
    },
    markInitiallyVisibleNotifications() {
      this.$nextTick(() => {
        this.notifications.forEach(notification => {
          const el = this.$el.querySelector(`[key="${notification.id}"]`);
          if (el) {
            const rect = el.getBoundingClientRect();
            if (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
              this.markAsViewed(notification);
            }
          }
        });
      });
    },

    updateNotifications() {
      this.notifications.forEach(notification => {
        if (notification.viewed !== notification.updateViewed) {
          api.get(`/lampNotification/changeNotifViewedState/${notification.id}`)
            .then(response => {
              notification.viewed = true
            })
            .catch(error => {
              if (!error.response) {
                console.log("error", error)
              }
            })
        }
      });
    },

    async updateNotifAndRedirect(notification, $event) {
      if (!notification.clicked) {
        await api.get(`/lampNotification/changeNotifClickedState/${notification.id}`)
          .catch(error => {
            if (!error.response) {
              console.log("error", error)
            }
          })
      }
      let redirect = null
      let paramName = null
      switch (notification.type) {
        case NotificationTypeEnum.ANNONCE_ACCEPTED:
        case NotificationTypeEnum.ANNONCE_REFUSED:
        case NotificationTypeEnum.NEW_NEAR_VEHICLES:
        case NotificationTypeEnum.NEW_ALERT_VEHICLES:
        case NotificationTypeEnum.ANNONCE_TO_COMPLETE:
        case NotificationTypeEnum.ANNONCE_DELAY_PASSED:
        case NotificationTypeEnum.PHOTOS_REFUSED:
          redirect = "AnnonceShow";
          paramName = 'annonceId'
          break;

        case NotificationTypeEnum.WATCHER_MATCH_INVALID:
        case NotificationTypeEnum.WATCHER_MATCH_REFUSED:
          redirect = "MatchShow";
          paramName = 'annonceId'
          break;
        default:
          redirect = null;
          break;
      }
      if (redirect && paramName && notification.objectId) {
        const currentRouteName = this.$route.name;
        const currentParams = this.$route.params;

        if (currentRouteName === redirect && currentParams[paramName] !== notification.objectId) {
          this.$router.replace({
            name: redirect,
            params: {
              [paramName]: notification.objectId
            }
          }).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err;
            }
          });

          this.$router.go(0)

        } else if (currentRouteName !== redirect) {
          this.$router.push({
            name: redirect,
            params: {
              [paramName]: notification.objectId
            }
          }).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err;
            }
          });
        }
      } else {
        $event.stopPropagation();
      }
    }
  }
}
</script>

<style scoped>
.lamp-notif-sized-container-for-mobile {
  display: block;
}

.lamp-notif-container {
  padding: 6px 10px;
}

.lamp-notif-container-mobile {
  height: calc(100vh - 75px);
  overflow-y: auto;
}

.lamp-no-notif {
  color: var(--main-black-lighter);
  display: flex;
  justify-content: center;
  font-family: Agbalumo-Regular, "Arial", sans-serif;
  padding-left: 10px;
  padding-right: 10px;
}

.lamp-notif {
  background-color: var(--main-black-light);
  border-radius: var(--main-border-radius);
  margin-top: 4px;
  margin-bottom: 4px;
}

.lamp-notif-content {
  white-space: pre-wrap;
  margin-bottom: 0px;
}

.lamp-notif-title {
  color: var(--main-white);
  font-weight: normal;
  padding-right: 5px;
}

.lamp-notif-timeText, .lamp-notif-description {
  color: var(--main-grey-medium);
}

.lamp-notif-timeText {
  font-size: 14px;
}

.lamp-notif-icon-part {
  min-width: 60px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.lamp-notif-texts-part {
  padding-right: 10px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.lamp-notif-new-part {
  min-width: 60px;
  margin-left: auto;
}

.lamp-notif-icon-part i {
  font-size: 35px;
}

.lamp-notif-icon-yellow {
  color: var(--main-yellow-medium);
}

.lamp-notif-icon-grey {
  color: var(--main-grey-dark);
}


.lamp-notif-new {
  margin-top: 18px;
  background-color: var(--main-yellow-medium);
  color: var(--main-black-light);
  font-size: 14px;
  font-weight: 600;
  padding: 2px 6px;
  height: 25px;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
}

.custom-color-success {
  color: var(--main-green-medium)
}

.custom-color-danger {
  color: var(--main-red-medium)
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.8s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */
{
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/menus/NotifsMenu.vue